import { NextPage } from 'next'
import Head from 'next/head'

import PriceTemplate from '~/components/templates/PriceTemplate'

const rowsAd = [
  {
    menu: '初期設定・初期クリエイティブ',
    price: '\xA550,000~',
    monthly: false,
  },
  {
    menu: 'ウェブ広告運用',
    price: '\xA530,000~',
    monthly: true,
  },
  {
    menu: 'マーケティング支援',
    price: '\xA550,000~',
    monthly: true,
  },
]

const rowsCreative = [
  {
    menu: 'ランディングページ制作',
    price: '\xA5100,000~',
    monthly: false,
  },
  {
    menu: 'ウェブサイト制作',
    price: '\xA5500,000~',
    monthly: false,
  },
  {
    menu: 'LPO/サイト改善支援',
    price: '\xA530,000~',
    monthly: true,
  },
  {
    menu: '画像クリエイティブ',
    price: '\xA55,000~',
    monthly: false,
  },
  {
    menu: '動画クリエイティブ',
    price: '\xA520,000~',
    monthly: false,
  },
]

const price: NextPage = () => {
  return (
    <>
      <Head>
        <title>料金・プラン | eduad</title>
        <meta
          name='description'
          content='eduad-エデュアド-は教育・スクール運営に特化したウェブマーケティング支援を行うプロフェッショナル技術者集団です。料金・プランの一覧です。詳しくはお気軽にお問い合わせください。'
        />
      </Head>
      <PriceTemplate
        title='料金・プラン'
        subtitle='Plan'
        rowsAd={rowsAd}
        rowsCreative={rowsCreative}
      />
    </>
  )
}

export default price
